import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import { Typography } from "components";
import { ROUTES } from "routes/routePaths";
import OnBoardingForm from "./OnboardingForm";
import "./style.scss";

const Onboarding = () => {
  const location = useLocation();
  const onBoardingState = location?.state?.onBoardingState;

  if (![1, 2, 3, 4].includes(onBoardingState))
    return <Navigate to={ROUTES.dashboard} />; //In case user tries to visit the route from url

  return (
    <div className="onboarding-container">
      <Typography conponent="h4" state="primary" variant="heading3">
        Profile Setup
      </Typography>
      <Typography variant="body2" state="secondary">
        Fill this Information for Account activation
      </Typography>

      <div style={{ marginTop: "3rem" }}>
        <OnBoardingForm currentStatus={onBoardingState} />
      </div>
    </div>
  );
};

export default Onboarding;
